import React from 'react';
import ErrorMessage from '../../shared/components/ErrorMessage';
import { ERRORS_CODES_WITH_BACK_BUTTON } from '../constants';
import { useInitialState } from '../contexts/InitialStateContext';

const LaravelErrors = () => {
  const state = useInitialState();

  return (
    <ErrorMessage
      backButtonLabel={state.backButton.label}
      code={state.error.code}
      details={state.error.details}
      message={state.error.message}
      showBackButton={ERRORS_CODES_WITH_BACK_BUTTON.includes(state.error.code)}
    />
  );
};

export default LaravelErrors;
